import React, { useEffect, useState } from 'react'
import { Container,Row,Col,Button,Spinner } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import './RightSidebar.css';

const styles = createUseStyles( theme => ({
    ButtonPrimary: {
        backgroundColor: theme.colorPrimary,
        borderColor: theme.colorPrimary,
    }
}) )


export const RightSidebarNuevaCotizacion = ({status,setStatus,children,title,props,onClose,onSave,loading}) => {

    const [btnLoading,setBtnLoading] = useState(false);

    const [windowDimenion, detectHW] = useState({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight,
    })

    const detectSize = () => {
        detectHW({
        winWidth: window.innerWidth,
        winHeight: window.innerHeight,
        })
    }

    useEffect(() => {
        setBtnLoading(loading);
    },[loading])
  
    useEffect(() => {
        window.addEventListener('resize', detectSize)
        return () => window.removeEventListener('resize', detectSize)
    }, [windowDimenion])

    let className = windowDimenion.winHeight > windowDimenion.winWidth ? "ws-right-siderbar-mobile " : "ws-right-siderbar"


  return (
    <div className={`${windowDimenion.winHeight > windowDimenion.winWidth ? "ws-right-siderbar-mobile " : "ws-right-siderbar"} ${ (status) && 'active' }`} {...props}>
        
        <Container>
            <Row>
                <Col xs={12}>
                    <div className="pt-2 pb-2 ps-1 pe-1 ws-sidebar-inter-right-header d-flex justify-content-between align-items-center">
                        <p className='mb-0 ws-sidebar-inter-right-header-title'>{title}</p>
                        <Button 
                        disabled={btnLoading}
                        className="ws-sidebar-inter-right-header-button" 
                        onClick={ 
                            () => onSave() 
                        }>
                            {
                                btnLoading ?
                                <>Agregando... <Spinner animation="border" size="sm" /></>
                                :
                                <><i className="bi bi-plus-circle"></i>&nbsp;Agregar</>
                            }
                        </Button>
                            <i className="material-icons ws-sidebar-right-close" 
                            onClick={
                                () => {
                                    setStatus(!status)
                                    onClose();
                                }
                            }>clear</i>
                    </div>
                </Col>
            </Row>
        </Container>
        <Container>
            <Row>
                <Col xs={12}>
                    <div className="p-3">
                        {children}
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
  )
}

export const RightSidebar = ({status,setStatus,children,title,props,onClose}) => {
  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  })


  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    })
  }

  return (
    <div className={`${windowDimenion.winHeight > windowDimenion.winWidth ? "ws-right-siderbar-mobile " : "ws-right-siderbar"} ${ (status) && 'active' }`} {...props}>
        <Container>
            <Row>
                <Col xs={12}>
                    <div className="p-3 ws-sidebar-right-header d-flex justify-content-between align-items-center">
                        <p className='mb-0 ws-sidebar-right-header-title'>{title}</p>
                        <i className="material-icons ws-sidebar-right-close" 
                        onClick={
                            () => {
                                setStatus(!status)
                                onClose();
                            }
                        }>clear</i>
                    </div>
                </Col>
            </Row>
        </Container>
        <Container>
            <Row>
                <Col xs={12}>
                    <div className="p-3">
                        {children}
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
  )
}
